module.exports = window["wp"]["commands"];